{
  "tickHz": 20,
  "gcdMs": 1000,
  "rangeToleranceM": 0.5,
  "hitChanceBase": 0.95,
  "hitChancePenaltyPerLevel": 0.03,
  "hitChanceMin": 0.05,
  "defFactor": 0.55,
  "damageRandMin": 0.9,
  "damageRandMax": 1.1,
  "critMult": 1.5,
  "critPerDex": 0.001,
  "critCap": 0.3,
  "pvpDamageMult": 0.6,
  "basicAttackMult": 0.5,
  "pvpHealMult": 0.7,
  "pvpHealWindowMs": 10000,
  "hpBase": 80,
  "hpPerVit": 12,
  "mpBase": 40,
  "mpPerInt": 8,
  "apPerPrimary": 2,
  "outOfCombatAfterMs": 5000,
  "regen": {
    "hpPctPerSecInCombat": 0,
    "hpPctPerSecOutOfCombat": 3,
    "mpPctPerSecInCombat": 0.5,
    "mpPctPerSecOutOfCombat": 5
  },
  "playerRespawnMs": 5000,
  "mobRespawn": { "crowdRangeM": 60, "perExtraPlayerPct": 12, "minPct": 40 },
  "townRecallMs": 2000,
  "bossAbilityGapMs": 3000,
  "partyBuffRangeM": 30,
  "classResistCapPct": 30,
  "elementResistCapPct": 50,
  "potions": {
    "cooldownMs": 2000,
    "hpBase": 80,
    "hpPerLevel": 6,
    "mpPoolPct": 3.2,
    "mpCooldownMs": 2000
  },
  "levelGrowth": {
    "from": 10,
    "cap": 60,
    "power": 2,
    "mobBonus": 0.6,
    "potionBonus": 0.6
  }
}
